<template>
  <div
    v-if="user.information"
    id="inbox-wrapper"
    v-bind:class="{ showFolders: showFolders }"
    :key="$route.fullPath"
  >
  
    <div id="inbox-sidebar" class="h-100 no-print" :key="redrawList">
      
      <i
        class="fal fa-chevron-right nav-icon clickable"
        v-show="!showFolders"
        @click="showFolders = true"
      ></i>
      <i
        class="fal fa-chevron-left nav-icon clickable"
        v-show="showFolders"
        @click="showFolders = false"
      ></i>
      
      <MessagesMenu_4_4
      v-if="checkValidVersion('4.4.0')"
        :functionbox_uuid="functionbox_uuid"
        :user_uuid="user_uuid"
        :sefosEnabled="sefosEnabled"
        :showFolders="showFolders"
        :is-mobile="device.isMobile"
        @closeFolders="closeFolders"
      ></MessagesMenu_4_4>

      
      <MessagesMenu
      v-if="!checkValidVersion('4.4.0')"
        :functionbox_uuid="functionbox_uuid"
        :user_uuid="user_uuid"
        :sefosEnabled="sefosEnabled"
        :showFolders="showFolders"
        :is-mobile="device.isMobile"
        @closeFolders="closeFolders"
      ></MessagesMenu>
      
    </div>

    <div id="inbox-content">
      <div class="w-100" v-if="message_uuid == ''">
        <div v-if="showInbox">
          <div class="mt-2 ml-2">
            <span v-if="sefosEnabled"
              ><img class="icon" src="/img/message_type/message.png" />
              {{ boxInformation.name }}, {{ boxInformation.email }}</span
            >
            <span v-if="boxInformation.fax || boxInformation.sdk">, </span>
            <span v-if="boxInformation.fax"
              ><img class="icon" src="/img/message_type/fax-message.png" />
              {{ boxInformation.fax }}
              <span v-if="boxInformation.sdk">, </span>
            </span>
            <span v-if="boxInformation.sdk"
              ><img class="icon" src="/img/message_type/sdk-message.png?id=2" />
              {{ boxInformation.sdk }}</span
            >
          </div>

          <b-form inline class="mt-2">
            <AddressBook
              v-if="checkValidVersion('4.3.0') && ShowAddressbook"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-slot:activator="{ onClick }"
              ><b-button
                @click="onClick"
                class="no-border"
                v-b-tooltip.hover
                :title="$t('ADDRESSBOOK.TITLE')"
              >
                <i class="fal fa-address-book"></i
              ></b-button>
            </AddressBook>

            <b-button @click="refreshList" class="no-border"
              ><i class="fal fa-sync"></i
            ></b-button>

            <AddMessage_4_4
              v-if="checkValidVersion('4.4.0')"
            @Close="CloseAddMessage"
            @Changed="Changed"
            :functionbox_uuid="functionbox_uuid"
            :user_uuid="user_uuid"
            :message="message"
          ></AddMessage_4_4>

          
            <AddMessage
                v-if="!checkValidVersion('4.4.0')"
              @sentMessage="sentMessage"
              :key="addMessageKey"
              :functionbox_uuid="functionbox_uuid"
              :user_uuid="user_uuid"
            ></AddMessage>

            <label class="sr-only" for="inline-form-input-search">{{
              $t("SEARCH")
            }}</label>
            <b-form-input
              trim
              id="inline-form-input-search"
              class="i-100 searchText hidden-mobile ml-2"
              v-model="searchText"
              :placeholder="$t('SEARCH')"
              @keydown.enter.prevent
            ></b-form-input>
            <label class="sr-only" for="inline-form-input-limit">{{
              $t("LIMIT")
            }}</label>
            <b-form-select
              id="inline-form-input-limit"
              name="messages_limit"
              v-model="limit"
              class="limit hidden-mobile"
            >
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="25">25</b-form-select-option>
              <b-form-select-option value="45">45</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </b-form>

          <div class="hidden-not-mobile w-100 mt-2">
            <b-form inline>
              <label class="sr-only" for="inline-form-input-search">{{
                $t("SEARCH")
              }}</label>
              <b-form-input
                trim
                class="ml-2 i-100 searchText"
                v-model="searchText"
                :placeholder="$t('SEARCH')"
                @keydown.enter.prevent
              ></b-form-input>
              <label class="sr-only" for="inline-form-input-limit">{{
                $t("LIMIT")
              }}</label>
              <b-form-select
                id="inline-form-input-limit"
                name="meetings_limit"
                v-model="limit"
                class="limit"
              >
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="25">25</b-form-select-option>
                <b-form-select-option value="45">45</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </b-form>
          </div>

          <router-view
            :key="addMessageKey"
            :searchText.sync="searchText"
            :limit.sync="limit"
            :functionbox_uuid="functionbox_uuid"
            :update_message_uuid="update_message_uuid"
            :user_uuid="user_uuid"
            @viewingNotification="viewingNotification"
            @viewingMessage="viewingMessage"
            @draftMessage="DraftMessage"
            @changeUpdateMessageUuid="changeUpdateMessageUuid"
          ></router-view>
        </div>
      </div>

      <div v-if="message_uuid != ''" class="w-100">

        <Notification
          v-if="notification && !checkValidVersion('4.4.0')"
          :notification="notification"
          :functionbox_uuid="functionbox_uuid"
          :user_uuid="user_uuid"
        ></Notification>

        <Message_4_4
          v-if="conversation_message_uuid == '' && checkValidVersion('4.4.0')"
          :message_uuid="message_uuid"
          :functionbox_uuid="functionbox_uuid"
          :user_uuid="user_uuid"
          show-close-btn
          @closeMessage="closeMessage"
          @showConversation="showConversation"
        ></Message_4_4>
        
        <Message 
        v-if="conversation_message_uuid == '' && !checkValidVersion('4.4.0')"
        :message_uuid="message_uuid"
        :functionbox_uuid="functionbox_uuid"
        :user_uuid="user_uuid"
        show-close-btn
        @closeMessage="closeMessage"
        @showConversation="showConversation"
      ></Message>

        <Conversation_4_4 v-if="conversation_message_uuid != '' && checkValidVersion('4.4.0')"
        :message_uuid="conversation_message_uuid"
        :inbox="true"
        :functionbox_uuid="functionbox_uuid"
        @gotoMessage="gotoMessage"
        @closeConversation="closeConversation"
        show-close-btn
        :user_uuid="user_uuid"></Conversation_4_4>
              
      <Conversation v-if="conversation_message_uuid != '' && !checkValidVersion('4.4.0')"
      :message_uuid="conversation_message_uuid"
      :inbox="true"
      :functionbox_uuid="functionbox_uuid"
      @gotoMessage="gotoMessage"
      @closeConversation="closeConversation"
      show-close-btn
      :user_uuid="user_uuid"></Conversation>

      </div>

    </div>
  </div>
</template>
<script>
import Notification from "@/components/View/Notification";
import MessagesMenu from "@/components/Layout/MessagesMenu";
import AddressBook from "@/components/AddressBook/Page";
import mobileDetect from "mobile-device-detect";
import Conversation from "@/components/Conversation/Conversation";
import AddMessage from "@/components/Compose/AddMessage";
import Message from "@/components/View/Message.vue";
import MessagesMenu_4_4 from "@/components_4_4/Layout/MessagesMenu";
import Conversation_4_4 from "@/components_4_4/Conversation/Conversation";
import AddMessage_4_4 from "@/components_4_4/Compose/AddMessage";
import Message_4_4 from "@/components_4_4/View/Message.vue";
export default {
  props: ["functionbox_uuid", "user_uuid", "email"],
  components: {
    Notification,
    MessagesMenu,
    AddMessage,
    Message,
    Conversation,
    AddressBook,
    MessagesMenu_4_4,
    AddMessage_4_4,
    Conversation_4_4,
    Message_4_4
  },
  data() {
    return {
      notification: null,
      device: mobileDetect,
      showFolders: false,
      message_uuid: "",
      conversation_message_uuid: "",
      searchText: "",
      limit: 45,
      information: null,
      modalShowSdk: false,
      modalShow: false,
      addMessageKeyIndex: 0,
      update_message_uuid: "",
      sefosEnabled: false,
      message: null
    };
  },
  methods: {
    Changed() {
      this.message = null;
      this.listMessageKeyIndex++;
    },
    CloseAddMessage() {
      this.message = null;
      this.listMessageKeyIndex++;
    },
    DraftMessage(message) {
      this.message = message;
    },
    closeFolders() {
      if (this.isMobile) {
        this.showFolders = false;
      }
      //this.addMessageKeyIndex++;
      this.notification = null;
      this.closeConversation();
      this.closeMessage();
    },
    changedFolders(val){
      this.showFolders = val;
    },
    GetSefosEnabled() {
      if (this.checkValidVersion("4.3.0")) {
        let self = this;
        this.$http
          .post(this.user.hostname + "/settings/get", {
            setting: "SefosMessage",
            functionbox_uuid: "",
            organisation_uuid:
              this.user.information.organisation.organisation_uuid,
          })
          .then(function (result) {
            self.sefosEnabled = result.data.enabled;
          })
          .catch(function () {});
      } else {
        this.sefosEnabled = true;
      }
    },
    changeUpdateMessageUuid(update_message_uuid) {
      this.update_message_uuid = update_message_uuid;
    },
    showConversation(message_uuid) {
      this.conversation_message_uuid = message_uuid;
    },
    closeConversation() {
      this.conversation_message_uuid = "";
    },
    gotoMessage(message_uuid) {
      this.notification = null;
      this.conversation_message_uuid = "";
      this.message_uuid = message_uuid;
    },
    hideModal() {
      this.modalShow = false;
    },
    hideModalSdk() {
      this.modalShowSdk = false;
    },
    sentMessage() {
      this.addMessageKeyIndex++;
    },
    refreshList() {
      this.addMessageKeyIndex++;
    },
    viewingMessage(message_uuid) {
      this.message_uuid = message_uuid;
      this.update_message_uuid = "";
    },
    viewingNotification(notification) {
      this.notification = notification;
      this.message_uuid = notification.message_uuid;
    },
    closeMessage() {
      if(this.message_uuid != "")
      {
        this.update_message_uuid = this.message_uuid;
        this.message_uuid = "";
      }
    },
    showSingle() {
      return this.functionbox_uuid == "";
    },
    showSdk() {
      if (this.user.services.sdk == undefined) {
        return false;
      } else {
        if (this.functionbox_uuid != "") {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  computed: {
    showInbox() {
      if (this.sefosEnabled == true && this.functionbox_uuid == "") {
        return true;
      }
      if (this.functionbox_uuid != "") {
        return true;
      }
      return false;
    },
    ShowAddressbook() {
      let self = this;
      if (!this.sefosEnabled) {
        let functionbox = this.user.functionboxes.items.filter(function (item) {
          return self.functionbox_uuid == item.functionbox_uuid;
        });
        if (functionbox.fax_enabled) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    boxInformation() {
      let boxInformationObj = {
        name: "",
        email: "",
        sdk: "",
        fax: "",
      };
      if (this.user_uuid == "" && this.functionbox_uuid == "") {
        boxInformationObj.name = this.user.information.name;
        boxInformationObj.email = this.user.information.email;
      } else {
        if (this.user_uuid != "") {
          for (let ix = 0; ix < this.user.delegatedboxes.items.length; ix++) {
            if (
              this.user.delegatedboxes.items[ix].user_uuid == this.user_uuid
            ) {
              boxInformationObj.name = this.user.delegatedboxes.items[ix].name;
              boxInformationObj.email =
                this.user.delegatedboxes.items[ix].email;
            }
          }
        } else {
          if (this.functionbox_uuid != "") {
            for (let ix = 0; ix < this.user.functionboxes.items.length; ix++) {
              if (
                this.user.functionboxes.items[ix].functionbox_uuid ==
                this.functionbox_uuid
              ) {
                boxInformationObj.name = this.user.functionboxes.items[ix].name;
                boxInformationObj.email =
                  this.user.functionboxes.items[ix].email;
                if (
                  this.user.functionboxes.items[ix].sdk_identifier != undefined
                ) {
                  boxInformationObj.sdk =
                    this.user.functionboxes.items[ix].sdk_identifier;
                }
                if (
                  this.user.functionboxes.items[ix].fax_identifier != undefined
                ) {
                  boxInformationObj.fax =
                    this.user.functionboxes.items[ix].fax_identifier;
                }
              }
            }
          }
        }
      }
      return boxInformationObj;
    },
    redrawList() {
      return this.$route.fullPath + "-" + this.user.new_message;
    },
    addMessageKey() {
      return "addMessage" + this.addMessageKeyIndex;
    },
  },
  mounted() {
    if(this.user.information)
    {
      this.showFolders = !this.device.isMobile;
      this.GetSefosEnabled();
    }
  },
};
</script>
<style></style>